import {ref} from "vue";
import {calcShippingService, checkTitleService, getAuctionService, getCitiesService, getPortsService} from "./api";

export const useCalcShipping = () => {

    const loading = ref({
        auction: false,
        port: false,
        location: false,
        calculation: false,
        titleCheck: false,
    });

    const locations = ref([]);
    const auctions = ref([]);
    const ports = ref([]);

    const location = ref({});
    const checkTitleValue = ref();
    const title = ref('');
    const selectedAuction = ref();
    const selectedLocation = ref();
    const getCities = async () => {
        loading.value.location = true;
        const res = await getCitiesService(selectedAuction.value);
        if (res) {
            locations.value = res.cities.sort((a, b) => {
                const nameA = a.state.toUpperCase();
                const nameB = b.state.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            }).map(loc => ({
                ...loc,
                label: `${loc.state} - ${loc.city_2}`
            }));
            loading.value.location = false;
        }
    }

    const getAuctions = async () => {
        loading.value.auction = true;
        const res = await getAuctionService();
        if (res) {
            auctions.value = res.auctions;
        }
        loading.value.auction = false;
    }


    const getPorts = async () => {
        loading.value.port = true;
        const res = await getPortsService();
        if (res) {
            ports.value = res.ports;
            loading.value.port = false;
        }
    }


    const checkTitle = async () => {
        loading.value.titleCheck = true;
        const res = await checkTitleService(title.value);

        if (res) {
            if (res[0] && res[0].title_en) {
                checkTitleValue.value = res[0].title_en
            } else {
                checkTitleValue.value = "Ask company"
            }
            loading.value.titleCheck = false;
        }
    }

    const calcShipping = async () => {
        loading.value.calculation = true;
        const res = await calcShippingService(selectedAuction.value, selectedLocation.value);
        if (res) {
            location.value = res.price[0];
            loading.value.calculation = false;
        }
    }

    return {
        location,
        checkTitleValue,
        selectedAuction,
        selectedLocation,
        loading,
        locations,
        auctions,
        ports,
        getCities,
        getAuctions,
        getPorts,
        checkTitle,
        calcShipping,
    }
};